export default __webpack_public_path__ + "static/media/13BEF4BE-214D-48A4-B0A8-1A3ECCABCFA3.e16d17ca.jpeg";